/**
 * External dependencies
 */
import React, { useState } from 'react';
import classNames from 'classnames';
import { Box } from '@towersystems/towersystems-design-system';
import './styles.scss';

const Button = ({
	primary = false,
	secondary = false,
	type = '',
	disabled = false,
	navItem = false,
	onClick = () => null,
	handlingOnClickContent = null,
	value = '',
	children,
	className,
	borderless = false,
	compact = false,
	lined = false,
	active = false,
	isActive,
	fullWidth,
	icon,
	link,
	text = false,
	...rest
}) => {
	const [handlingClick, setHandlingClick] = useState(false);
	//const buttonDOM = useRef(null);

	const buttonStyles = classNames([
		className,
		'btn',
		{ 'is-primary': primary },
		{ 'is-borderless': borderless },
		{ 'is-secondary': secondary },
		{ 'is-compact': compact },
		{ 'is-lined': lined },
		{ 'is-icon': icon },
		{ 'is-text': text },
		{ 'full-width': fullWidth },
		{ disabled: disabled },
		{ active: isActive || active },
	]);

	const handleOnClick = async (e) => {
		setHandlingClick(true);
		onClick && (await onClick());
		setHandlingClick(false);

		// to stop the button from being focused even after events have happened
		// e.g a modal was opened
		//
		// without this, the button would remain focused even after closing modal
		// until the user clicks again
		//buttonDOM.current && buttonDOM.current.blur();
	};

	const component = link ? 'a' : 'button';

	return (
		<Box
			type={type}
			value={value}
			onClick={handleOnClick}
			disabled={disabled || handlingClick}
			//ref={buttonDOM}
			{...rest}
			className={buttonStyles}
			component={component}
			href={link && link.toString()}
		>
			{(handlingClick && handlingOnClickContent) || children}
		</Box>
	);
};

export default Button;
